var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8587 33.011C24.5386 33.011 24.2184 32.931 23.8869 32.7823L20.8113 31.3303C20.777 31.3189 20.6513 31.3189 20.6055 31.3303L17.5528 32.7709C16.8783 33.0911 16.1694 33.0796 15.6206 32.7252C15.0489 32.3593 14.7174 31.6848 14.7288 30.8844L14.7402 22.4466C14.7402 21.9779 15.1061 21.5663 15.5977 21.5891C16.0665 21.5891 16.4552 21.9779 16.4552 22.4466L16.4438 30.8844C16.4438 31.136 16.5124 31.2617 16.5467 31.2732C16.5696 31.2846 16.6725 31.296 16.8325 31.216L19.8967 29.764C20.3883 29.5353 21.0629 29.5353 21.5545 29.764L24.6301 31.216C24.7901 31.296 24.893 31.2846 24.9159 31.2732C24.9502 31.2503 25.0188 31.1245 25.0188 30.8844V22.2408C25.0188 21.772 25.4075 21.3833 25.8763 21.3833C26.3451 21.3833 26.7338 21.772 26.7338 22.2408V30.8844C26.7338 31.6962 26.4022 32.3593 25.8306 32.7252C25.5333 32.9195 25.2017 33.011 24.8587 33.011Z",
    fill: "#6F8EF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7195 25.0075C15.9861 25.0075 12.1445 21.2917 12.1445 16.7184C12.1445 12.145 15.9861 8.4292 20.7195 8.4292C25.4529 8.4292 29.2945 12.145 29.2945 16.7184C29.2945 21.2917 25.4529 25.0075 20.7195 25.0075ZM20.7195 10.1442C16.9351 10.1442 13.8595 13.094 13.8595 16.7184C13.8595 20.3427 16.9351 23.2925 20.7195 23.2925C24.504 23.2925 27.5795 20.3427 27.5795 16.7184C27.5795 13.094 24.504 10.1442 20.7195 10.1442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.271df978b5cdd7889a06155cbbb7caef.svg";
export { ForwardRef as ReactComponent };